import type { LayoutDataType } from '../../types';

export const FIRST_IMPRESSION_OPTIONS: {
  id: NonNullable<LayoutDataType['first_impression']>;
  title: string;
}[] = [
  {
    id: 'eyes',
    title: 'Her eyes',
  },
  {
    id: 'attitude',
    title: 'Her attitude',
  },
  {
    id: 'outfit',
    title: 'Her... outfit',
  },
];
